// containers/LinkPartnerPage.jsx
import React from "react";
import Layout from "../components/Layout";
import BackButton from "../siteSetting/components/BackButton";
import { partnerArray } from "../store/localItems";
import ContainerProductPage from "../components/ContainerProductPage/ContainerProductPage";

const LinkPartnerPage = () => {
    return (
        <Layout sidebar>
            <div style={{ marginTop: 20 }}>
                <BackButton text="На главную" href="/" />
            </div>
            <ContainerProductPage
                items={partnerArray}
                getTo={(x) => x.href}
                getTitle={(x) => x.text}
                getImage={(x) => x.photo}
            />
        </Layout>
    );
};

export default LinkPartnerPage;
